import React from 'react'
import { getObjValue } from '@hlj/hlj-utils'
import mStore from '../../store'

export default merchantInfo => [
  {
    title: '产品内容',
    key: 'name',
    dataIndex: 'product',
    width: '15%',
    render: product => {
      return getObjValue(product, 'title')
    }
  },
  {
    title: '购买内容',
    key: 'content',
    dataIndex: 'num_type',
    width: '35%',
    render: (num_type, record) => {
      let {
        num,
        ad,
        quantity,
        set_meal_count,
        serving_type,
        sell_condition_text
      } = record
      let content = ''
      if ((ad == 101 || ad == 125) && (num_type == 1 || num_type == 5)) {
        content = `套包数量：${num_type == 1 ? quantity : num}个`
      } else if (num_type == '1') {
        content = `服务期限：${num}个月`
      } else if (num_type == '2') {
        content = `充值金额：${num}元`
      } else if (num_type == '3') {
        content = `服务次数：${num}次`
      } else if (num_type == '5') {
        content = `个数：${num}个`
      } else if (num_type == '6') {
        content = `服务期限: ${num}天，此时间可能随时间而变化`
      }
      const showType = {
        '1': '每月一周',
        '2': '每月两周',
        '3': '每月四周'
      }
      const showTypeContent = showType[quantity] || ' 每天展示'
      const settedPackage = set_meal_count => {
        return (
          <span>
            推广套餐
            {!set_meal_count && (
              <i style={{ color: '#f83244', fontStyle: 'normal' }}>未设置</i>
            )}
            {!!set_meal_count &&
              set_meal_count != 0 &&
              `已设置${set_meal_count}个`}
            , 点击<a
              href="javascript:;"
              onClick={mStore.toggleSettingModal.bind(this, record)}
            >
              这里
            </a>
            {set_meal_count == 0 ? '设置' : '查看'}
          </span>
        )
      }
      if (ad == 270) {
        const payStatus = mStore.details.status // 是否已付款
        const {
          configured_ring_brand, // 是否已配置品牌页
          parent_id,
          has_ring_brand // 是否有品牌页配置入口
        } = merchantInfo
        const showBrandLink =
          payStatus && !configured_ring_brand && !parent_id && has_ring_brand
        return (
          <>
            <span>{content}</span>
            <span>{showTypeContent}</span>
            {showBrandLink && (
              <span>
                &nbsp;品牌页未配置，点击<a
                  href="#/localMerchant/brand"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  这里
                </a>去配置
              </span>
            )}
            {sell_condition_text && (
              <div style={{ color: '#999999', marginTop: 2, maxWidth: 380 }}>
                {sell_condition_text}
              </div>
            )}
          </>
        )
      }
      if (
        !serving_type ||
        serving_type == 2 ||
        mStore.details.status != 1 ||
        new Date(mStore.details.pay_time).getTime() <
          new Date('2019-05-01').getTime()
      ) {
        return (
          <div>
            {content}
            {sell_condition_text && (
              <div style={{ color: '#999999', marginTop: 2, maxWidth: 380 }}>
                {sell_condition_text}
              </div>
            )}
          </div>
        )
      }
      return (
        <React.Fragment>
          <span>{content}</span>
          <span>{showTypeContent}</span>
          {settedPackage(set_meal_count)}
          {sell_condition_text && (
            <div style={{ color: '#999999', marginTop: 2, maxWidth: 380 }}>
              {sell_condition_text}
            </div>
          )}
        </React.Fragment>
      )
    }
  },
  // {
  //   title: '说明',
  //   key: 'desc',
  //   dataIndex: 'desc',
  //   render: (desc, { city }) => {
  //     let desc_detail = desc ? desc + ',' : '',
  //       city_detail = city ? '展示城市：' + city : ''
  //     return desc_detail + city_detail
  //   }
  // },
  {
    title: '服务协议',
    key: 'protocol',
    width: '15%',
    dataIndex: 'product',
    render: (product, { protocol_content, protocol_title }) => {
      let item = product || {}
      return (
        <>
          {protocol_title && (
            <span
              key={item.id}
              style={{ cursor: 'pointer', color: '#448afc' }}
              onClick={mStore.showProtocolModal(
                protocol_title,
                protocol_content
              )}
            >
              {protocol_title && '《' + protocol_title + '》'}
            </span>
          )}
        </>
      )
    }
  },
  {
    title: '售价',
    key: 'order_money',
    width: '15%',
    render: ({ original_money }) => {
      return (
        <span style={{ color: '#ff801a' }}>
          {original_money && '¥ ' + original_money}
        </span>
      )
    }
  }
]
